module.exports = __webpack_public_path__ + "img/home.533aa8f0.svg";